<template>
    <div>
        <b-modal id="create-custom-doc" title="Create a new custom document" scrollable hide-footer>
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" class="form-control" id="name" v-model="name" />
                <label for="path">File</label>
                <input type="file" class="form-control" id="file" @change="selectedFile" />
                <label for="description">Description</label>
                <input type="text" class="form-control" id="description" v-model="description" />
                <label for="ack_required">Ack Required</label>
                <select class="form-control" id="ack_required" v-model="ack_required">
                    <option value="1">Active</option>
                    <option value="0">InActive</option>
                </select>
                <label for="ack_message">Ack Message</label>
                <input type="text" class="form-control" id="ack_message" v-model="ack_message" />
                <label for="selected">Selected</label>
                <select class="form-control" id="selected" v-model="selected">
                    <option value="1">Active</option>
                    <option value="0">InActive</option>
                </select>
                <label for="sort_order">Sort Order</label>
                <input type="text" class="form-control" id="sort_order" v-model="sort_order" />
                <label for="status">Status</label>
                <select class="form-control" id="status" v-model="status">
                    <option value="1">Active</option>
                    <option value="0">InActive</option>
                </select>
                <label for="document_type_id">Document Type Id</label>
                <input type="text" class="form-control" id="document_type_id" v-model="document_type_id" />
                <label for="properties">Properties</label>
                <input type="text" class="form-control" id="properties" v-model="properties" />
                <div class="newUserButtonContainer">
                    <b-button @click="closeModal('create-custom-doc')">Cancel</b-button>
                    <b-button @click="saveNewCustomDoc">Create</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
.newUserButtonContainer {
    display: flex;
    justify-content: space-between;
}
</style>

<script>
import Vue from 'vue'
// resources
import CustomDocResource from '../../resources/custom_doc'
// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    data() {
        return {
            name: '',
            description: '',
            ack_required: 1,
            ack_message: '',
            file: '',
            selected: 0,
            sort_order: '',
            status: 1,
            document_type_id: '',
            properties: '',
            customDocResource: null,
            isSaving: false,
        }
    },
    mixins: [modalMixin, toastMixin],
    methods: {
        // Set defaults
        setInitialValues() {
            this.status = 1
            this.selected = 0
            this.ack_required = 0
            this.properties = JSON.stringify({
                entities: [],
                required: false,
                start_doc: false,
                union_doc: false,
                nonunion_doc: false,
                loanout_doc: false,
                nonloanout_doc: false,
                overrides: [],
                departments: null,
                locations: null,
            })
        },
        selectedFile() {
            let fileData = document.getElementById('file').files[0]
            this.getBase64(fileData)
                .then((encodedFile) => (this.file = encodedFile))
                .catch((err) => this.createToast('b-toaster-top-center', 'danger', true, 'File Upload Error', err))
        },

        getBase64(file) {
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader()
                fileReader.readAsDataURL(file)
                fileReader.onload = () => {
                    resolve(fileReader.result)
                }
                fileReader.onerror = (error) => {
                    reject(error)
                }
            })
        },
        async saveNewCustomDoc() {
            // set all values
            this.customDocResource.set('name', this.name)
            this.customDocResource.set('description', this.description)
            this.customDocResource.set('path', this.file)
            this.customDocResource.set('ack_required', this.ack_required)
            this.customDocResource.set('ack_message', this.ack_message)
            this.customDocResource.set('selected', this.selected)
            this.customDocResource.set('sort_order', this.sort_order)
            this.customDocResource.set('properties', this.properties)
            this.customDocResource.set('status', this.status)
            this.customDocResource.set('document_type_id', this.document_type_id)

            let errors = this.customDocResource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                try {
                    this.isSaving = true
                    const result = await this.customDocResource.save()
                    if (result.response.status === 200 || result.response.status === 201) {
                        this.createToast('b-toaster-top-center', 'success', true, 'Custom Document Created', '')
                        this.closeModal('create-custom-doc')
                    }
                } catch (error) {
                    this.createToast('b-toaster-top-center', 'danger', true, 'Custom Document Creation Error', 'Error')
                    throw error
                }
                this.isSaving = false
            }
        },
    },
    mounted() {
        this.customDocResource = new CustomDocResource()
        this.setInitialValues()
    },
})
</script>
